import {StyleSheet} from 'react-native';

import {
  cloudLight,
  cloudLightest,
  denim,
  neutral200,
  onyx,
  white,
} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  container: {
    flex: 1,
    backgroundColor: cloudLightest,
  },
  header: {
    paddingVertical: 20,
    backgroundColor: white,
  },
  content: {
    paddingBottom: 20,
  },
  section: {
    flex: 1,
    backgroundColor: white,
    marginTop: 20,
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  buttons: {
    marginVertical: 20,
    marginHorizontal: 16,
    flexDirection: 'row',
    gap: 16,
  },
  button: {
    flex: 1,
  },
  datePicker: {
    marginTop: 10,
    alignSelf: 'center',
    width: '100%',
  },
  webDatePickerContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingVertical: 10,
  },
  webDatePicker: {
    width: '90%',
    maxWidth: 400,
    padding: 12,
    fontSize: 16,
    color: onyx,
    borderRadius: 8,
    borderWidth: 1.5,
    borderColor: cloudLight,
    backgroundColor: white,
    outlineColor: denim,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  warning: {
    flexDirection: 'row',
    marginBottom: 10,
    marginRight: 10,
  },
  icon: {
    marginRight: 5,
  },
  formField: {
    textInput: {
      borderWidth: 1,
      borderColor: neutral200,
      borderRadius: 4,
      paddingHorizontal: 8,
      paddingVertical: 4,
      marginTop: 4,
      minHeight: 40,
    },
  },
  formFieldRow: {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      marginVertical: 4,
    },
    labelContainer: {
      flex: 1,
      marginRight: 16,
    },
    textInputWithShowButton: {
      flex: 2,
    },
    textInput: {
      borderWidth: 1,
      borderColor: neutral200,
      borderRadius: 4,
      paddingHorizontal: 8,
      paddingVertical: 4,
      minHeight: 40,
      width: '100%',
    },
  },
});
